import React from "react";
import { Card, CardBody, CardHeader, Modal, Col, Container, Row, Alert, Button, ModalHeader, ModalFooter, ModalBody, Collapse } from 'reactstrap';
import { LoadingSpinner } from "../../../components";
import PageTitle from "../../../components/common/PageTitle";
import Select from 'react-select';
import { connect } from "react-redux";
import {
    deleteFeature,
    Delete,
    SelectAllFeatureListMG,
    SelectAllFeatureListME,
    SelectByGroup,
    SelectByGroupAll,
} from "../../../api/Feature";

import FeatureEntry from "./FeatureEntry";

class FeatureList extends React.Component {

    static routeName = '/setup/feature';

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            Subdata: [],
            isLoading: false,

            errorMessage: "",
            successMessage: "",

            //For Select MG
            dropdownData: [],
            //All List of Feature From DB
            allFeaturesList: [],
            allSubFeaturesList: [],
            featureValue: { label: "All", values: 0 },
            //Display User Selected Data
            Features: [],
            SubFeatures: [],

            IsCollapse: -1,
            SelectMainMenu: '',

        }
    }

    async componentDidMount() {
        this.loadData();
    }

    async loadDataAfterDelete() {
        this.updateDropDown("featureValue", { label: "All", values: "All" }) //Change "All" word in Dropdown
        let allFeaturesList = await SelectAllFeatureListMG(); //Get Feature Item After Delete
        let allSubFeaturesList = await SelectAllFeatureListME();
        let dropdownData = [{ label: "All", value: "All" }]; //For reset FeatureList
        allFeaturesList.forEach((obj) => { //For reset Dropdown 
            if (obj.menuType === "MG") {
                dropdownData.push({ label: obj.menuName, value: obj.menuGroupCode });
            }
        });
        this.setState({ Features: allFeaturesList, dropdownData, SubFeatures: allSubFeaturesList })
    }

    async loadData() {
        this.setState({ isLoading: true })
        let { data, Subdata } = this.state;
        this.state.allFeaturesList = await SelectAllFeatureListMG();
        this.state.allSubFeaturesList = await SelectAllFeatureListME();
        // console.log('allstubfeaturelist', this.state.allSubFeaturesList)
        let dropdownData = [{ label: "All", value: "All" }]; // add dropdown options
        //Only Main Menu For Dropdown 
        this.state.allFeaturesList.forEach((obj) => {
            if (obj.menuType === "MG") {
                dropdownData.push({ label: obj.menuName, value: obj.menuGroupCode });
            }
        });
        //All Item MG
        this.state.allFeaturesList.forEach(itm => {
            data.push({
                featureId: itm.featureId,
                menuName: itm.menuName,
                menuType: itm.menuType,
                menuGroupCode: itm.menuGroupCode,
                defaultExpanse: itm.defaultExpanse,
                extendedPerm: itm.extendedPerm,
                menuCode: itm.menuCode,
                moduleCode: itm.moduleCode,
                pageURL: itm.pageURL,
            })
        });

        //All Item ME
        this.state.allSubFeaturesList.forEach(itm => {
            Subdata.push({
                featureId: itm.featureId,
                menuName: itm.menuName,
                menuType: itm.menuType,
                menuGroupCode: itm.menuGroupCode,
                defaultExpanse: itm.defaultExpanse,
                extendedPerm: itm.extendedPerm,
                menuCode: itm.menuCode,
                moduleCode: itm.moduleCode,
                pageURL: itm.pageURL,
            })
        });

        this.setState({ isLoading: false, Features: data, dropdownData, data, SubFeatures: Subdata });
    }

    async updateDropDown(prop, value) {
        let allFeaturesListMG = await SelectAllFeatureListMG();
        if (prop === "featureValue") {
            if (value.value === "All") {
                this.setState({ Features: allFeaturesListMG, IsCollapse: -1 });
            } else {
                const selectedItem = (allFeaturesListMG.filter((itm) => {
                    if (itm.menuGroupCode === value.value) {
                        return itm;
                    }
                }))
                this.setState({
                    Features: selectedItem,
                    IsCollapse: -1
                });
            }
        }
        this.setState({ [prop]: value });
    }

    clearMessages() {
        this.setState({
            errorMessage: "",
            successMessage: ""
        });
    }

    Subtoggle(index) {
        const { deleteModal } = this.state;
        this.setState({ deleteModal: deleteModal === index ? -1 : index });
    }

    MainToggle(index) {
        const { MdeleteModal } = this.state;
        this.setState({ MdeleteModal: MdeleteModal === index ? -1 : index });
    }

    async handleDelete(rowObj) {
        this.setState({ isLoading: true });
        this.clearMessages();
        let res;
        if (rowObj != null) {
            res = await Delete(rowObj.featureId,rowObj.menuType,rowObj.menuGroupCode)
        }

        if (res.status) {
            this.setState({ successMessage: "Delete " + rowObj.menuCode + " Successfully.", deleteModal: -1, isLoading: false });
            this.loadDataAfterDelete();
        } else {
            console.log('work')
            this.setState({ errorMessage: res.message, deleteModal: -1,MdeleteModal: -1, isLoading: false });
        }
    }

    handleEdit(featureID, item) {
        this.props.history.push({ pathname: `${FeatureEntry.routeName}/${featureID}`, state: item });
    }

    handleCreate() {
        this.props.history.push({ pathname: FeatureEntry.routeName });
    }

    DisplaySubMenu(idx, name, W) {
        if (W === "C") {
            if (this.state.IsCollapse === -1) {
                this.setState({ IsCollapse: idx, SelectMainMenu: name });
            } else if (this.state.IsCollapse === idx) {
                this.setState({ IsCollapse: -1 });
            } else if (this.state.IsCollapse !== idx) {
                this.setState({ IsCollapse: -1, IsCollapse: idx, SelectMainMenu: name });
            }
        }

    }

    renderRoleListTable(Features) {
        if (Features.length <= 0) return <b>No Data To Show</b>;
        return (
            Features.map((item, idx) => {
                return (
                    <tbody>
                        <tr key={item.featureId} className="d-flex">
                            <td class="col-2" onClick={() => this.DisplaySubMenu(idx, item.menuGroupCode, "C")}>{item.menuName}</td>
                            <td class="col-2">{item.menuCode}</td>
                            <td class="col-2">{item.menuGroupCode}</td>
                            <td class="col-2">{item.moduleCode}</td>
                            <td class="col-2">{item.pageURL}</td>
                            <td className="active" class="col-2">
                                <Col>
                                    <Button style={{ marginTop: "5px" }} color="primary" onClick={() => this.handleEdit(item.featureId, item)} > <i className="fa fa-edit"></i></Button>
                                    &nbsp;
                                    <Button style={{ marginTop: "5px" }} color="danger" onClick={() => this.MainToggle(idx)}> <i className="fa fa-trash"></i></Button>
                                </Col>
                            </td>

                            <Modal isOpen={this.state.MdeleteModal === idx} MainToggle={() => this.MainToggle(idx)}>
                                <ModalHeader toggle={() => this.MainToggle(idx)}>Delete Feature Name</ModalHeader>
                                <ModalBody>
                                    Are you sure you want to delete "{item.menuCode}"?
                                </ModalBody>
                                <ModalFooter>
                                    <Button color="danger" onClick={() => this.handleDelete(item)}>Yes</Button>
                                    <Button color="secondary" onClick={() => this.MainToggle(idx)}>No</Button>
                                </ModalFooter>
                            </Modal>
                        </tr>

                        <Collapse isOpen={this.state.IsCollapse === idx} onClick={() => this.DisplaySubMenu(idx, "C")} style={{ marginBottom: 30, backgroundColor: "lightsteelblue" }}>
                            {this.state.SubFeatures.map((item, subidx) => {
                                const data = item.menuGroupCode;
                                return (
                                    data === this.state.SelectMainMenu ?
                                        <tr className="d-flex">
                                            <td class="col-2">{item.menuName}</td>
                                            <td class="col-2">{item.menuCode}</td>
                                            <td class="col-2">{item.menuGroupCode}</td>
                                            <td class="col-2">{item.moduleCode}</td>
                                            <td class="col-2">{item.pageURL}</td>
                                            <td>
                                                <Col>
                                                    <Button style={{ marginTop: "5px" }} color="primary" onClick={() => this.handleEdit(item.featureId, item)} > <i className="fa fa-edit"></i></Button>
                                                    &nbsp;
                                                    <Button style={{ marginTop: "5px" }} color="danger" onClick={() => this.Subtoggle(subidx)}> <i className="fa fa-trash"></i></Button>
                                                </Col>
                                            </td>

                                            <Modal isOpen={this.state.deleteModal === subidx} Subtoggle={() => this.Subtoggle(subidx)}>
                                                <ModalHeader toggle={() => this.Subtoggle(subidx)}>Delete Feature Name</ModalHeader>
                                                <ModalBody>
                                                    Are you sure you want to delete "{item.menuCode}"?
                                                </ModalBody>
                                                <ModalFooter>
                                                    <Button color="danger" onClick={() => this.handleDelete(item)}>Yes</Button>
                                                    <Button color="secondary" onClick={() => this.Subtoggle(subidx)}>No</Button>
                                                </ModalFooter>
                                            </Modal>
                                        </tr>
                                        :
                                        ""
                                )
                            })}
                        </Collapse>


                    </tbody>
                )
            }
            )
        )
    }

    render() {

        return (
            <>
                {this.state.isLoading && <LoadingSpinner />}
                <Container fluid className="main-content-container px-12">
                    <Row noGutters className="page-header py-4">
                        <PageTitle sm="4" title="Feature List" className="text-sm-left" />
                    </Row>
                    <Row>
                        {this.state.isLoading && <LoadingSpinner />}
                        <Col xs={12} lg={12}>
                            <Card>
                                <CardHeader >
                                    <Row sm={12} >
                                        <Col sm={10}>
                                            <Select
                                                options={this.state.dropdownData}
                                                value={this.state.featureValue}
                                                onChange={(value) => this.updateDropDown("featureValue", value)}
                                            />
                                        </Col>
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        <Button color="primary" onClick={() => this.handleCreate()}>New Feature</Button>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    {this.state.errorMessage !== "" &&
                                        <Alert theme="danger">{this.state.errorMessage}</Alert>
                                    }
                                    {this.state.successMessage !== "" &&
                                        <Alert theme="success">{this.state.successMessage}</Alert>
                                    }
                                    <div className="table-responsive container-fluid">
                                        <table className="table table-bordered table-hover" >
                                            <thead className="">
                                                <tr className="text-center d-flex ">
                                                    <th class="col-2" bgcolor="#C8F4F8">Menu Name</th>
                                                    <th class="col-2" bgcolor="#C8F4F8">Menu Code</th>
                                                    <th class="col-2" bgcolor="#C8F4F8">Menu Group</th>
                                                    <th class="col-2" bgcolor="#C8F4F8">Modul Code</th>
                                                    <th class="col-2" bgcolor="#C8F4F8">PageURL</th>
                                                    <th class="col-2" bgcolor="#C8F4F8">action</th>
                                                </tr>
                                            </thead>
                                            {this.renderRoleListTable(this.state.Features)}
                                        </table>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </>
        )
    }


}


function mapStateToProps(state) {
    return { auth: state.auth };
}
export default connect(mapStateToProps)(FeatureList);


